//slide
const options = {
	type: "fade",
	arrows: false,
	pagination: true,
	gap: 0,
	perPage: 1,
	speed: 1500,
};

const homeSplide = document.getElementById('homeSplide');
if (homeSplide != null) {
	const slide1 = new Splide(homeSplide, options);
	slide1.mount();
}
